import React, { useState, useEffect } from 'react';
import { Input, Button, Card, Row, Col, message, Space } from 'antd';
import GenericAddRemoveMultipleRecords from './GenericAddRemoveMultipleRecordsUI';

const CreateGroup = ({ userList = [], editingGroup = {}, isEdit = false, onCancel, onSave }) => {
  const [name, setName] = useState('');
  const [apiName, setApiName] = useState('');
  const [description, setDescription] = useState('');
  const [selectedItems, setSelectedItems] = useState([]);
 
  useEffect(() => {
    if (isEdit && editingGroup) {
      setName(editingGroup.name || '');
      setApiName(editingGroup.apiName || '');
      setDescription(editingGroup.description || '');
      setSelectedItems(editingGroup.user_ids || []);
    }
  }, [isEdit, editingGroup]);

  const handleSave = () => {
    if (!name.trim() ) {
          message.error('Group name  is required.');
          return;
        }
        else if(!apiName.trim()){
            message.error('Api name  is required.');
            return;
        }
        else if(selectedItems.length === 0){
            message.error('Please select users');
            return;
        }

    const payload = {
      name,
      apiName,
      description,
      user_ids: selectedItems,
    };

    onSave(payload);
  };
  const generateApiName = (label) => {
    return label
      .replace(/[^a-zA-Z]/g, '') // Remove all characters except letters (a-z, A-Z)
      .replace(/\s+/g, '')       // Remove all spaces
      .trim();
  };

  return (
    <Card title={isEdit ? 'Edit Group' : 'Create Group'}>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Input
            placeholder="Group Name"
            value={name}
            onChange={(e) => {
              const value = e.target.value;
              setName(value);
              setApiName(generateApiName(value));
            }}
            
          />
        </Col>
        <Col span={24}>
          <Input
            placeholder="API Name"
            value={apiName}
            onChange={(e) =>
               setApiName(e.target.value)}
          />
        </Col>
        <Col span={24}>
          <Input.TextArea
            placeholder="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={4}
          />
        </Col>
      </Row>
      <Space style={{ marginTop: 16 }}>          

      <GenericAddRemoveMultipleRecords
        titleLeft="Available Users"
        titleRight="Selected Users"
        dataSource={userList}
        selectedKeys={selectedItems}
        onUpdateSelectedKeys={setSelectedItems}
        columnsLeft={[{ title: 'Name', dataIndex: 'Name', key: 'Name' }]}
        columnsRight={[{ title: 'Name', dataIndex: 'Name', key: 'Name' }]}
        searchFields={['Name', 'username']}
      />
    </Space>
      {/* Floating Buttons */}
      <div style={fullWidthFloatingButtonContainerStyle}>
        <Button onClick={onCancel} style={{ marginRight: 16 }}>
          Cancel
        </Button>
        <Button type="primary" onClick={handleSave}>
          Save
        </Button>
      </div>
    </Card>
  );
};

// CSS for the full-width floating button container
const fullWidthFloatingButtonContainerStyle = {
  position: 'fixed',
  bottom: 0, // Align to the bottom of the screen
  left: 0, // Start from the left edge
  width: '100%', // Make it span the entire width of the screen
  backgroundColor: '#fff', // Background color to stand out
  zIndex: 1000, // Ensure it stays on top of other elements
  padding: '10px 20px', // Add some padding
  textAlign: 'center', // Center the buttons horizontally
  boxShadow: '0 -2px 6px rgba(0, 0, 0, 0.2)', // Add a shadow for a floating effect
  borderTop: '1px solid #e8e8e8', // Optional: Add a border for separation
};

export default CreateGroup;
